import { useState, createContext } from "react";
import ReactDOM from "react-dom/client";

const UserContext = createContext()

export default UserContext